import { render } from "./Empleado.vue?vue&type=template&id=6609dc2c"
import script from "./Empleado.vue?vue&type=script&lang=js"
export * from "./Empleado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__